/**
 * Category-grouped chips to filter students by a missing field.
 */
export default function MissingFieldFilters({
  byField = [],
  byCategory = [],
  selectedKey,
  onSelect,
  onClear,
}) {
  const categories = byCategory.length
    ? byCategory
    : [...new Set(byField.map((f) => f.category))].map((category) => ({
        category,
        label: byField.find((f) => f.category === category)?.categoryLabel || category,
      }));

  return (
    <div className="mb-6 space-y-4">
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-sm font-medium theme-text">Filter by missing field</span>
        {selectedKey ? (
          <button
            type="button"
            onClick={onClear}
            className="text-xs underline theme-text-secondary"
          >
            Clear field filter
          </button>
        ) : null}
      </div>

      {categories.map((cat) => {
        const fields = byField.filter((f) => f.category === cat.category);
        if (!fields.length) return null;
        return (
          <div key={cat.category}>
            <p className="text-xs uppercase tracking-wide theme-text-secondary mb-2">
              {cat.label || cat.category}
              {typeof cat.missingStudentCount === 'number'
                ? ` · ${cat.missingStudentCount} student(s) missing something here`
                : ''}
            </p>
            <div className="flex flex-wrap gap-2">
              {fields.map((field) => {
                const active = selectedKey === field.key;
                return (
                  <button
                    key={field.key}
                    type="button"
                    onClick={() => onSelect(field.key)}
                    className="px-3 py-1.5 rounded-md text-sm border transition-colors"
                    style={{
                      borderColor: active
                        ? 'var(--color-primary, #2563eb)'
                        : 'var(--color-border)',
                      backgroundColor: active
                        ? 'var(--color-surface-secondary)'
                        : 'var(--color-surface)',
                      color: 'var(--color-text)',
                      fontWeight: active ? 600 : 400,
                    }}
                  >
                    {field.label}
                    <span className="theme-text-secondary ml-1">({field.missingCount})</span>
                  </button>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
